export default {
    init: function ( $element ) {
        "use strict";
        var _this = this;

        _this.$body = $element;
        _this.$overlay = $element.find( ".overlay" );

        return _this;
    },

    activate: function () {
        "use strict";
        var _this = this;

        //Close sidebar
        $( window )
            .click( function ( e ) {
                var $target = $( e.target );
                if ( e.target.nodeName.toLowerCase() === "i" ) {
                    $target = $( e.target )
                        .parent();
                }

                if ( !$target.hasClass( "bars" ) && _this.isOpen() && $target.parents( "#leftsidebar" )
                    .length === 0 ) {
                    if ( !$target.hasClass( "js-right-sidebar" ) ) {
                        _this.$overlay.fadeOut();
                    }
                    _this.$body.removeClass( "overlay-open" );
                }
            } );

        $.each( $( ".menu-toggle.toggled" ), function ( i, val ) {
			if( $( val ).next().is(":visible") ){
				$( val )
					.next()
					.slideToggle( 0 );
			}
        } );

		$( ".menu-toggle.toggled" ).removeClass("toggled");

        //When page load
        $.each( $( ".menu .list li.active" ), function ( i, val ) {
            var $activeAnchors = $( val )
                .find( "a:eq(0)" );

            $activeAnchors.addClass( "toggled" );
            $activeAnchors.next().show();
        } );

		$( ".menu-toggle" ).unbind("click");
        // Collapse or Expand Menu
        $( ".menu-toggle" )
            .on( "click", function ( e ) {
                var $this = $( this );
                var $content = $this.next();

                // Don't allow the sub-menu to expand when the sidebar menu only displayed the icon.
                if (_this.$body.hasClass("sidebar-closed")) {
                    return;
                }

                if ( $( $this.parents( "ul" )[ 0 ] )
                    .hasClass( "list" ) ) {
                    var $not = $( e.target )
                        .hasClass( "menu-toggle" ) ? e.target : $( e.target )
                        .parents( ".menu-toggle" );

                    $.each( $( ".menu-toggle.toggled" )
                        .not( $not )
                        .next(),
                        function ( i, val ) {
                            if ( $( val )
                                .is( ":visible" ) ) {
                                $( val )
                                    .prev()
                                    .toggleClass( "toggled" );
                                $( val )
                                    .slideUp();
                            }
                        } );
                }

                $this.toggleClass( "toggled" );
                $content.slideToggle( 320 );
            } );

        //Set active menu
        $( ".ml-menu" )
            .on( "click", "li", function ( e ) {
                e.stopPropagation();
                var $this = $( this ),
                    $li = $this.parent()
                    .children();

                $.each( $li, function ( index, el ) {
                    var $anchor = $( el )
                        .find( "a:eq(0)" );

                    if ( $( el ).hasClass( "active" ) ) {
                        $( el ).removeClass( "active" );
                    }
                    if ( $anchor.hasClass( "toggled" ) ) {
                        $anchor.removeClass( "toggled" );
                        return false;
                    }
                } );

                $this.addClass( "active" );
                $this.find( "a:eq(0)" )
                    .addClass( "toggled" );
            } );

        //Set menu height
        _this.setMenuHeight();
        _this.checkStatusForResize( true );

        var resizeId;
        $( window )
            .resize( function () {
                clearTimeout( resizeId );
                resizeId = setTimeout( function () {
                    _this.setMenuHeight();
                    _this.checkStatusForResize( false );
                }, 20 );
            } );

        //Set Waves
        Waves.attach( ".menu .list a", [ "waves-block" ] );
        Waves.init();
    },

    setMenuHeight: function () {
        "use strict";
        if ( typeof $.fn.slimScroll !== "undefined" ) {
            var configs = VtAdmin.options.leftSideBar;
            var height = ( $( window )
                .height() - ( $( ".legal" )
                    .outerHeight() + $( ".user-info" )
                    .outerHeight() + $( ".navbar" )
                    .innerHeight() ) );
            var $el = $( ".list" );

            $el.slimScroll( {
                    destroy: true
                } )
                .height( "auto" );

            $el.parent()
                .find( ".slimScrollBar, .slimScrollRail" )
                .remove();

            $el.slimscroll( {
                height: height + "px",
                color: configs.scrollColor,
                size: configs.scrollWidth,
                alwaysVisible: configs.scrollAlwaysVisible,
                borderRadius: configs.scrollBorderRadius,
                railBorderRadius: configs.scrollRailBorderRadius
            } );
        }
    },

    checkStatusForResize: function ( firstTime ) {
        "use strict";
        var _this = this;
        var $openCloseBar = $( ".navbar .navbar-header .bars" );
        var $openCloseSidebar = $( ".sidebar-toggle" );
        var width = _this.$body.width();

        if ( firstTime ) {
            _this.$body.find( ".content, .sidebar" )
                .addClass( "no-animate" )
                .delay( 1000 )
                .queue( function () {
                    $( this )
                        .removeClass( "no-animate" )
                        .dequeue();
                } );
        }

        if ( width < 1170 ) {
            _this.$body.addClass( "ls-closed" );
            $openCloseBar.fadeIn();
            $openCloseSidebar.fadeOut();
        } else {
            _this.$body.removeClass( "ls-closed" );
            _this.$body.removeClass( "overlay-open" );
            _this.$overlay.fadeOut();
            $openCloseBar.fadeOut();
            $openCloseSidebar.fadeIn();

        }
    },

    isOpen: function () {
        "use strict";
        var _this = this;
        return _this.$body.hasClass( "overlay-open" );
    }
};
